import { EuiFlexGroup, EuiFlexItem } from "@elastic/eui";
import React, { useEffect, useState } from "react";
import { useMapDataToUiWithFilter } from "hooks/mapDataToOptions";
import { ButtonRow } from "styles/elements/main";
import { Button, SelectWithSearch } from "components";
import FilterLabel from "modules/shared/profiles/filters/FilterLabel";
import { PAYMENT_METHODS, QA_STATUS, SUPPLIER_TYPES } from "modules/shared/profiles/constants";
import { HAS_ACOMPANY } from "../staticData";
import trackAnalytics from "trackAnalytics";

const SuppliersFilters = ({ setSuppliersFiltersOptinos, filterOptions }) => {
    const {
        data: governorates,
        setSearchFilter: setGovernoratesFilter,
        clearSearchFilter: clearGovernoratesFilter,
    } = useMapDataToUiWithFilter("governorates");
    const {
        data: truckTypes,
        setSearchFilter: setTruckTypesFilter,
        clearSearchFilter: clearTruckTypesFilter,
    } = useMapDataToUiWithFilter("truck-types", "truckTypes");
    const [filters, setFilters] = useState({});
    const [totalFilters, setTotalFilters] = useState(0);

    const analyticsEvents = {
        supplierType: "Filter_supplier_by_type_clicked",
        workingGovernorates: "Filter_supplier_by_governorate_clicked",
        truckTypeId: "Filter_supplier_by_truck_type_clicked",
        hasACompany: "Filter_supplier_by_has_company_clicked",
        paymentMethodType: "Filter_supplier_by_payment_method_clicked",
        qaStatus: "Filter_supplier_by_status_clicked",
    };

    useEffect(() => {
        const sum = Object?.values(filters)?.reduce((acc, curr) => acc + curr?.value?.length, 0);
        setTotalFilters(sum);
    }, [filterOptions]);

    const handelClearAllFilters = () => {
        const updatedFilters = {};
        for (const filter in filters) {
            updatedFilters[filter] = { value: [] };
        }
        setFilters(updatedFilters);
        setSuppliersFiltersOptinos([]);
    };

    const handleClearSingleFilter = (filterName) => {
        const filtered = { ...filterOptions[0] };
        delete filtered[filterName];
        setFilters((prev) => ({ ...prev, [filterName]: { value: [] } }));
        setSuppliersFiltersOptinos([filtered]);
    };

    const handleApplyFilter = (id, name, newFilters) => {
        const appliedOptions = [];
        let filterValues = [];
        const updatedFilters = newFilters || filters;
        for (const option in updatedFilters) {
            if (updatedFilters[option].id === id) {
                const filter = updatedFilters[option];
                filterValues = filter.value.map((element) => element.label);
                appliedOptions.push({ ...updatedFilters, [option]: filter });
            }
        }
        if (analyticsEvents[name]) {
            trackAnalytics(analyticsEvents[name], {
                "Filter Value": filterValues,
            });
        }
        setSuppliersFiltersOptinos(appliedOptions);
    };

    const handleChangedData = (value, name, id) => {
        const newFilters = {
            ...filters,
            [name]: { value, id },
        };
        setFilters(newFilters);
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < filterOptions?.length; i++) {
            if (newFilters[name]?.value?.length < filterOptions[i][name]?.value?.length) {
                handleApplyFilter(id, name, newFilters);
            }
        }
    };
    const constantsCustomSearchFilter = (filterType, value) => {
        return filterType.filter((item) => item.label.toLowerCase().includes(value.toLowerCase()));
    };

    const ActionBtns = ({ name, id }) => (
        <ButtonRow>
            <Button
                name="Clear"
                type="button"
                btnStyle="secondBtn"
                onChange={() => handleClearSingleFilter(name)}
            />
            <Button
                name="Apply"
                onChange={() => handleApplyFilter(id, name)}
                type="button"
                btnStyle="primaryBtn"
            />
        </ButtonRow>
    );
    return (
        <>
            <FilterLabel
                handelClearAllFilters={handelClearAllFilters}
                filtersCount={totalFilters}
            />
            <EuiFlexGroup
                className="step-container"
                gutterSize="s"
            >
                <EuiFlexItem>
                    <SelectWithSearch
                        placeholder="Supplier Type"
                        name="supplierType"
                        customBtns={
                            <ActionBtns
                                name="supplierType"
                                id={1}
                            />
                        }
                        isEditable
                        value={filters?.supplierType?.value}
                        isMulti
                        handleChange={(value) => handleChangedData(value, "supplierType", 1)}
                        handleFilter={(filter) =>
                            constantsCustomSearchFilter(SUPPLIER_TYPES, filter)
                        }
                        options={SUPPLIER_TYPES}
                    />
                </EuiFlexItem>
                <EuiFlexItem>
                    <SelectWithSearch
                        placeholder="Working Governerate"
                        name="workingGovernorates"
                        isEditable
                        customBtns={
                            <ActionBtns
                                name="workingGovernorates"
                                id={2}
                            />
                        }
                        isMulti
                        value={filters?.workingGovernorates?.value}
                        options={governorates}
                        handleChange={(value) => {
                            handleChangedData(value, "workingGovernorates", 2);
                            clearGovernoratesFilter();
                        }}
                        handleFilter={(filter) => {
                            setGovernoratesFilter(filter);
                            return governorates;
                        }}
                        onMenuClose={() => clearGovernoratesFilter()}
                    />
                </EuiFlexItem>
                <EuiFlexItem>
                    <SelectWithSearch
                        placeholder="Truck Type"
                        name="truckTypeId"
                        customBtns={
                            <ActionBtns
                                name="truckTypeId"
                                id={3}
                            />
                        }
                        value={filters?.truckTypeId?.value}
                        isEditable
                        handleChange={(value) => {
                            handleChangedData(value, "truckTypeId", 3);
                            clearTruckTypesFilter();
                        }}
                        isMulti
                        handleFilter={(filter) => setTruckTypesFilter(filter)}
                        options={truckTypes}
                        onMenuClose={() => clearTruckTypesFilter()}
                    />
                </EuiFlexItem>
                <EuiFlexItem>
                    <SelectWithSearch
                        placeholder="Has a Company"
                        name="hasACompany"
                        value={filters?.hasACompany?.value}
                        customBtns={
                            <ActionBtns
                                name="hasACompany"
                                id={4}
                            />
                        }
                        isEditable
                        isMulti
                        handleChange={(value) => handleChangedData(value, "hasACompany", 4)}
                        options={HAS_ACOMPANY}
                    />
                </EuiFlexItem>
                <EuiFlexItem>
                    <SelectWithSearch
                        placeholder="Payment Method"
                        name="paymentMethodType"
                        isEditable
                        customBtns={
                            <ActionBtns
                                name="paymentMethodType"
                                id={5}
                            />
                        }
                        isMulti
                        value={filters?.paymentMethodType?.value}
                        handleChange={(value) => handleChangedData(value, "paymentMethodType", 5)}
                        handleFilter={(filter) =>
                            constantsCustomSearchFilter(PAYMENT_METHODS, filter)
                        }
                        options={PAYMENT_METHODS}
                    />
                </EuiFlexItem>
                <EuiFlexItem>
                    <SelectWithSearch
                        placeholder="Status"
                        name="qaStatus"
                        isEditable
                        customBtns={
                            <ActionBtns
                                name="qaStatus"
                                id={6}
                            />
                        }
                        isMulti
                        value={filters?.qaStatus?.value}
                        handleChange={(value) => handleChangedData(value, "qaStatus", 6)}
                        handleFilter={(filter) => constantsCustomSearchFilter(QA_STATUS, filter)}
                        options={QA_STATUS}
                    />
                </EuiFlexItem>
            </EuiFlexGroup>
        </>
    );
};

export default SuppliersFilters;
